<div class="flex flex-row items-center"
  [ngClass]="{
    '-ml-[30px]': routeType === 'idea' || routeType === 'problem',
    }"
  >
    
    <button (click)="onUpvote()">
      <ark-lib-icon-name
        [name]="item.upVoteMine ? 'like-active' : 'like'"
      ></ark-lib-icon-name>
    </button>
    <div
      class="text-black text-[11px] font-normal leading-[18px] mx-[5px] mr-2"
    >
      {{ item.upVoteCount | numberAbbrevation }}
    </div>
    <button (click)="onDownvote()">
      <ark-lib-icon-name
        [name]="item.downVoteMine ? 'dislike-active' : 'dislike'"
      ></ark-lib-icon-name>
    </button>
    <div
      *ngIf="displayDownVoteCount"
      class="text-black text-[11px] font-normal leading-[18px] mx-[5px]"
    >
      {{ item.downVoteCount | numberAbbrevation  }}
    </div>
</div>